import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";


export const DefaultPrinterUpdateSlice = createSlice({
  name: "DefaultPrinterUpdateSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    DefaultPrinterUpdate: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successDefaultPrinterUpdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureDefaultPrinterUpdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDefaultPrinterUpdate: (state) => {
      state.data = {};
    },
  },
});

export const {
  DefaultPrinterUpdate,
  successDefaultPrinterUpdate,
  failureDefaultPrinterUpdate,
  clearDefaultPrinterUpdate,
} = DefaultPrinterUpdateSlice.actions;

export default DefaultPrinterUpdateSlice.reducer;
